import React, { useState } from 'react'
import FormImage from '../FormImageBox';
import { FormBoxHeading, FormBoxWrapper, FormRightBox, FormSubmitBtn } from '../FormsStyled';
import { Button } from 'components/Button';
import { InputFieldStyle, NeedAnAccount } from '../FormsStyled';
import { FormErrorColor, MenuModelText } from '../ModalStyled';
import { useForm, SubmitHandler } from 'react-hook-form';
import { Link, useHistory } from "react-router-dom"
import axios from 'libs/axios';
import { Box } from 'components/Box';
import { ReactComponent as BackIcon } from 'assets/Icons/BackIcon.svg';
import ForgotpasswordModal from '../ForgotPassword/ForgotpasswordModal';
import { toast } from 'react-toastify';
import { setUser } from 'state/user';
import { useAppDispatch } from 'state';

type Inputs = {
    email: string,
    password: string,
};

const Login: React.FC = () => {
    const dispatch = useAppDispatch();

    const [open, setOpen] = useState(false);
    const { register, handleSubmit, formState: { errors } } = useForm<Inputs>();

    const history = useHistory();
    const [loading, setLoading] = useState(true);

    const onSubmit: SubmitHandler<Inputs> = async data => {
        try {
            setLoading(true);
            const result = await axios.post('/user/login', data);
            toast.success(result.data.message);
            localStorage.setItem('Gamesfi_Current_User', JSON.stringify(result.data.token));
            history.push("/home");
            dispatch(setUser({ authToken: result.data.token, user: null }));
            setOpen(true);
        } catch (err) {
            //@ts-ignore
            toast.error(err.response.data.message);
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <FormBoxWrapper>

                <FormImage />

                <Box>
                    <Box display={['none', 'none', 'none', 'block']}>
                        <Link to="/">
                            <BackIcon />
                        </Link>
                    </Box>

                    <FormRightBox>
                        <FormBoxHeading>LOGIN TO YOUR ACCOUNT</FormBoxHeading>

                        <form onSubmit={handleSubmit(onSubmit)}>

                            <InputFieldStyle>
                                <label>Email</label>
                                <input type="email" className="form-control" {...register("email", { required: { value: true, message: "Email is Required" }, pattern: { value: /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/, message: "Invalid Email" } })} />
                                <FormErrorColor>{errors.email && errors.email.message}</FormErrorColor>
                            </InputFieldStyle>

                            <InputFieldStyle>
                                <label>Password</label>
                                <input type="password" className="form-control" {...register("password", { required: { value: true, message: "Password is Required" } })} />
                                <FormErrorColor>{errors.password && errors.password.message}</FormErrorColor>
                            </InputFieldStyle>

                            <ForgotpasswordModal />

                            <FormSubmitBtn>
                                <Button type="submit">LOGIN</Button>
                            </FormSubmitBtn>

                            <NeedAnAccount>
                                <MenuModelText>Don’t have an account?</MenuModelText>
                                <Link to='/signup'>Signup</Link>
                            </NeedAnAccount>

                        </form>
                        {/* <Link to='/confirmemail'>Confirm Email</Link><br></br>
                    <Link to='/passwordconfirm'>Confirm Password</Link> */}
                    </FormRightBox>
                </Box>
            </FormBoxWrapper>
        </>
    )
}

export default Login